import { render, staticRenderFns } from "./PluginsExternalTab.vue?vue&type=template&id=628b5e07&scoped=true&"
import script from "./PluginsExternalTab.vue?vue&type=script&lang=js&"
export * from "./PluginsExternalTab.vue?vue&type=script&lang=js&"
import style0 from "./PluginsExternalTab.vue?vue&type=style&index=0&id=628b5e07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b5e07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBtn,VIcon,VSimpleTable})
